import { configure, makeAutoObservable } from "mobx";
class MyGridStore {
    props = {
        columnDefs: [],
        data: null,
        enablePaginationControls: false,
        expanded: null
    }

    constructor() {
        makeAutoObservable(this);
        configure({
            enforceActions: 'never',
        })
    }

    clear() {
        this.props = {
            columnDefs: [],
            data: null,
            enablePaginationControls: false,
            expanded: null
        }
    }
}


const myGrid = new MyGridStore();

export default myGrid;
